import { render, staticRenderFns } from "./Publicar.vue?vue&type=template&id=18743956&scoped=true"
import script from "./Publicar.vue?vue&type=script&lang=js"
export * from "./Publicar.vue?vue&type=script&lang=js"
import style0 from "./Publicar.vue?vue&type=style&index=0&id=18743956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18743956",
  null
  
)

export default component.exports